'use client';

import { c } from '../../../utils/tailwind-merge';
import { UserReviewInfo } from '../../molecules/UserReviewInfo';
import { UserReview } from '../UserReview';
import { UserProductReviewProps } from './UserProductReview.types';

export const UserProductReview = ({
  reviewerInfo,
  reviewDetails,
  onSubmitReport,
  onEditReview,
  onEditReply,
  onDeleteReply,
  onSubmitReply,
  onEmailPublisher,
  onSubmitReview,
  onDeleteReview,
  microcopy,
  className,
}: UserProductReviewProps) => {
  return (
    <div className={c('block w-full gap-5 md:flex', className)}>
      <UserReviewInfo
        {...reviewerInfo}
        microcopy={microcopy.reviewerInfo}
        link={reviewerInfo.link || ''}
        avatarUrl={reviewerInfo.avatarUrl || ''}
        className="mb-5 md:mb-0"
      />
      <UserReview
        onSubmitReport={onSubmitReport}
        onEditReview={onEditReview}
        onEditReply={onEditReply}
        onDeleteReply={onDeleteReply}
        onSubmitReply={onSubmitReply}
        onEmailPublisher={onEmailPublisher}
        onSubmitReview={onSubmitReview}
        onDeleteReview={onDeleteReview}
        {...reviewDetails}
        microcopy={microcopy.reviewDetails}
      />
    </div>
  );
};
